<template>
    <div class="loading">
        <b-loading :is-full-page="true" active></b-loading>
    </div>
</template>

<style lang="scss" scoped>
.loading {
    height: calc(100vh - 144px);
}
</style>

<script>
import { safeNext } from '../util/safeNext'

export default {
    name: 'Authenticate',
    beforeMount() {
        const fragment = new URLSearchParams(window.location.hash.slice(1));
        const token = fragment.get('access_token');
        //const tokenType = fragment.get('token_type');
        const maxAge = fragment.get('expires_in');
        let cookie = `token=${encodeURIComponent(token)}; max-age=${maxAge};`// domain=${window.location.host}`
        document.cookie = cookie;
        this.$store.commit('setToken', token)

        /*
         * `state` is whatever came back from Discord, and Discord will return
         * anything it was given — including a state set by a link someone else
         * wrote. Validated here as well as where it is set, because this is the
         * line that actually navigates: it was unreachable while nothing set a
         * state, and stopped being unreachable the moment /login started to.
         *
         * Not decoded again on the way in. URLSearchParams already
         * percent-decodes what it returns, so a second pass would turn an
         * encoded query value back into a literal one — `?ref=a%20b` becomes a
         * real space, which is then rejected — and would throw outright on a
         * stray `%`.
         */
        const next = safeNext(fragment.get('state') || '')
        window.location = next || '/shop'

        this.$gtag.event('login')
    }
}
</script>
